import { Grid } from "@material-ui/core";
import { Button } from "../../shared/components/button";
import { Category } from "../lesson-collectable-category-list";
import { LessonCollectableCategoryStyles } from "./lesson-collectable-category.styles";
import clsx from "clsx";
import { LockIcon } from "../../shared/icons";

interface LessonCollectableCategoryProps extends Category {
  onCategorySelected: (categoryId) => void;
  isSaveEnabled: boolean;
  isSelected: boolean;
}

export const LessonCollectableCategory = (
  props: LessonCollectableCategoryProps
) => {
  const { id, name, isPrivate, onCategorySelected, isSaveEnabled, isSelected } =
    props;
  const classes = LessonCollectableCategoryStyles();

  const renderCategoryIcon = (name) => {
    return (
      <div
        className={clsx(classes.categoryIcon, {
          ["featured"]: name.toLowerCase() === "all",
        })}
      >
        {name.charAt(0).toUpperCase()}
      </div>
    );
  };

  const handleSaveCollectable = () => {
    onCategorySelected(id > 0 ? id : null);
  };

  return (
    <Grid
      container
      spacing={0}
      className={[classes.item, classes.categoryBackground].join(" ")}
    >
      {isSelected && (
        <>
          <Grid item xs={12} md={12}>
            <div className={classes.categorySelected}>
              {renderCategoryIcon(name)}
              <div
                className={[classes.itemSavedInLabel, classes.tTruncate].join(
                  " "
                )}
              >
                Item saved in <b>{name}</b>
              </div>
            </div>
          </Grid>
        </>
      )}
      {!isSelected && (
        <>
          <Grid item xs={8} md={8}>
            <div className={classes.category}>
              {renderCategoryIcon(name)}
              <div
                className={[classes.categoryName, classes.tTruncate].join(" ")}
              >
                {name}
              </div>
            </div>
          </Grid>
          <Grid item xs={4} md={4}>
            <div className={classes.categoryActions}>
              {isSaveEnabled && isPrivate && (
                <LockIcon className={classes.lockIcon} />
              )}
              {isSaveEnabled && (
                <Button
                  className={classes.saveButton}
                  variant="contained"
                  color="primary"
                  onClick={handleSaveCollectable}
                >
                  Save
                </Button>
              )}
            </div>
          </Grid>
        </>
      )}
    </Grid>
  );
};
